import { BehaviorSubject } from 'rxjs'
import {
  ShiftServiceProxy,
  CalendarServiceProxy,
  CalendarSimpleVO,
} from '@/service-proxies/app-v2/time.service-proxies'
import i18n from '@/locales'
import { Shift, Loading, Visible } from './types'
import { getRandomColor } from './utils'

const ssp = new ShiftServiceProxy()
const csp = new CalendarServiceProxy()

export const state = {
  calendarList: new BehaviorSubject<CalendarSimpleVO[]>([]),
  year: new BehaviorSubject(0),
  shiftList: new BehaviorSubject<Shift[]>([]),
  loading: new BehaviorSubject<Loading>({
    calendarTable: false,
    calendarDetail: true,
    createForm: false,
    updateForm: false,
    configureForm: false,
  }),
  visible: new BehaviorSubject<Visible>({ createForm: false, updateForm: false, configureForm: false }),
  currentCalendarId: new BehaviorSubject(''),
  currentCalendarDetail: new BehaviorSubject<CalendarSimpleVO>(null),
  specificCalendarContent: new BehaviorSubject<{ codeYear: any[] }>(null),
  currentCreateCodeYear: new BehaviorSubject(''),
}

export const actions = {
  setYear(year: number) {
    state.year.next(year)
  },
  setShiftList(shiftList: Shift[]) {
    state.shiftList.next(shiftList)
  },
  setLoading(loading: Loading) {
    state.loading.next({ ...state.loading.value, ...loading })
  },
  setVisible(visible: Visible) {
    state.visible.next({ ...state.visible.value, ...visible })
  },
  async loadShiftList() {
    const res = await ssp.getShiftList({ statusList: [1] } as any)
    const temp = res.map(item => ({ ...item, colour: item.colour || getRandomColor() }))
    state.shiftList.next(temp)
  },
  async loadCalendarList() {
    state.loading.next({ ...state.loading.value, calendarTable: true })
    try {
      const filterStatusList = { statusList: [1] } as any
      const res = await csp.getPageCalendar(filterStatusList, 1, 999)
      state.calendarList.next(res.records)
      for (let record of res.records) {
        state.specificCalendarContent[`${record.code}${record.year}`] = []
      }
      if (
        !state.currentCalendarId.value ||
        !state.calendarList.value.find(item => item.id === state.currentCalendarId.value)
      ) {
        if (!!res.records[0]) {
          state.currentCalendarId.next(res.records[0].id)
        } else {
          // state.currentCalendarId.next('')
        }
      }
      state.loading.next({ ...state.loading.value, calendarTable: false })
    } catch (e) {
      state.loading.next({ ...state.loading.value, calendarTable: false })
    }
  },
  async loadCalendarDetail() {
    state.loading.next({ ...state.loading.value, calendarDetail: true })
    try {
      const res = await csp.getCalendarDetail(state.currentCalendarId.value)
      console.log(res)
      state.currentCalendarDetail.next(res)
      state.loading.next({ ...state.loading.value, calendarDetail: false })
    } catch (e) {
      state.loading.next({ ...state.loading.value, calendarDetail: false })
    }
  },
  setCalendarDetail(detail) {
    state.currentCalendarDetail.next(detail)
  },
  setCurrentCalendarId(id: string) {
    state.currentCalendarId.next(id)
  },
}
